import type { StatusTone } from "@grizzly/shared";
import { cn } from "../../lib/cn.js";

const toneClasses: Record<StatusTone, string> = {
  neutral: "bg-status-neutral/10 text-status-neutral border-status-neutral/30",
  ready: "bg-status-ready/10 text-status-ready border-status-ready/30",
  active: "bg-status-active/10 text-status-active border-status-active/30",
  hold: "bg-status-hold/10 text-status-hold border-status-hold/30",
  risk: "bg-status-risk/10 text-status-risk border-status-risk/30",
  complete: "bg-status-complete/10 text-status-complete border-status-complete/30",
};

export function Badge({
  tone = "neutral",
  children,
  className,
}: {
  tone?: StatusTone;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        toneClasses[tone],
        className
      )}
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      {children}
    </span>
  );
}
